<template>
  <v-container fluid>
    <h2 class="page-title mb-1">Renovaciones</h2>
    <p class="page-desc mb-4">
      Contratos ordenados por cercanía a su vencimiento, con el MRR en juego y cuánto
      se está usando. Los contratos sin fecha de término no vencen nunca según el
      sistema: aparecen aparte para cargarles la fecha.
    </p>

    <ContractRenewalsTable />
  </v-container>
</template>

<script>
import ContractRenewalsTable from '@/components/ContractRenewalsTable.vue';

export default {
  name: 'Renovaciones',
  components: { ContractRenewalsTable },
};
</script>

<style scoped>
.page-title {
  color: #104b94;
  font-weight: 700;
}
.page-desc {
  font-size: 13px;
  color: #555;
  max-width: 720px;
}
</style>
